module.exports = __webpack_public_path__ + "img/grid-item-kynorelle-04.fe3780fa.webp";